import {
  liquidationStatus,
  gasMovementsStatus,
  typesUnitsOpt,
} from "helpers/dictionary";
import { useRuleValidator } from "hooks/useRuleValidator";
import { useToggle } from "hooks/useToggle";
import React, { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeSettlementNote } from "redux/actions/routesStatus/routesStatusAction";
import { PERMISSIONS } from "router/permissions";
import FlipCameraAndroidIcon from "@mui/icons-material/FlipCameraAndroid";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";

export const useColumnsHooks = ({
  original,
  key = "type",
  setValues,
  values,
}) => {
  const { ENDOWMENTS_DEL_NOTE, ENDOWMENTS_REASSIGNMENT_FOLIO, ENDOWMENTS_SETTLEMENTS } = PERMISSIONS;

  const dispatch = useDispatch();
  const PORTATIL = typesUnitsOpt[1].value;

  const { settlement, payments } = useSelector(({ routesStatus }) => routesStatus);
  const { isLoadingComp } = useSelector(({ search }) => search);

  const [open, setOpen] = useToggle();
  const [openDel, setOpenDel] = useToggle();
  const [openUpdate, setOpenUpdate] = useToggle();
  const [openReassign, setOpenReassign] = useToggle();

  const creditMethod = payments.find(py => py.name === "CREDITO").id === original.idPayment
  
  const ERP = "ERP"
  const isDelRule = useRuleValidator(ENDOWMENTS_DEL_NOTE);
  const isUpdateRule = useRuleValidator(ENDOWMENTS_REASSIGNMENT_FOLIO);
  const canView = useRuleValidator(ENDOWMENTS_SETTLEMENTS)
  const currentStatus = settlement.settlementStatus;
  const customerCodeERP = original?.customer?.code?.split("-")[0];

  const CREDIT_TYPES = ["credito", "condonacion", "nota nacional"];
  const routePayments = settlement?.routes?.start?.payments || "MIXED";
  const notePaymentLabel = original?.methodPayment?.toLowerCase() || "";
  const isNoteBlockedByRoute = useMemo(() => {
    if (routePayments === "MIXED") return false;
    if (routePayments === "CASH") return CREDIT_TYPES.includes(notePaymentLabel);
    if (routePayments === "CREDIT") return !CREDIT_TYPES.includes(notePaymentLabel);
    return false;
  }, [routePayments, notePaymentLabel]);

  const showEdit =
    canView && currentStatus !== liquidationStatus.value.CONFIRMED && !isNoteBlockedByRoute;
  const showDelete =
    isDelRule && currentStatus !== liquidationStatus.value.CONFIRMED;
  const showUpdate = currentStatus === liquidationStatus.value.CONFIRMED &&
    customerCodeERP === ERP && creditMethod && isUpdateRule;
  const showReassign =
    isUpdateRule && currentStatus === liquidationStatus.value.CONFIRMED;

  const blockBtn = currentStatus === liquidationStatus.value.ON_HOLD;
  // ---------------------
  const handleProductColumn = useMemo(() => {
    if (!original?.details) return;
    const names = original.details.map((a) => a.name);
    const unique = [...new Set(names)];
    if (unique.length > 1) {
      return <div>MULTI-PRODUCTO</div>;
    }
    return <div>{original?.name}</div>;
  }, [original?.details]);

  const handleTypeColumn = useMemo(() => {
    if (!original) return;
    return (
      <div>
        {original?.[key] === gasMovementsStatus.GAS_MOVEMENT
          ? "MOVIMIENTO DE GAS"
          : original?.[key]}
      </div>
    );
  }, [original]);

  const handleQuantityColumn = useMemo(() => {
    if (!original?.name || !original?.details) return;
    const { name, details } = original;
    if (name?.toLowerCase()?.includes("multi")) {
      const qTotal = details.reduce((acc, curr) => {
        return acc + curr.quantity * curr.capacity;
      }, 0);

      return <div>{qTotal}</div>;
    }
    return <div>{original?.quantity}</div>;
  }, [original?.name, original?.details]);

  // ACCCIONES
  const handleRemoveNote = useCallback(() => {
    original.id.length < 15
      ? dispatch(removeSettlementNote(original.id))
      : setOpenDel();
  }, [original?.id]);

  const handleEdit = useCallback(() => {
    setValues({
      product: values.editNote
        ? values.products.find((pr) => pr.id === original.idProduct)
        : original.product,
      quantity: original.quantity,
      price: original.price,
      amountDetail: original.amount,
      discount: original.discount,
      isEdit: true,
      noteDetailID: original.id,
    });
  }, [values, setValues, original]);

  const handleRemove = useCallback(() => {
    const details = values.noteDetails.filter(
      (item) => item.id !== original.id,
    );
    const discountDel = details.reduce((acc, curr) => acc + curr.discount, 0);
    setValues({
      amountDetail:
        values?.unitType === PORTATIL
          ? values.unitPriceKg
          : values?.unitPriceLt || 0,
      quantity: 0,
      noteDetails: details,
      discount: discountDel,
      amount: values.noteDetails.length === 1 ? 0 : values.amount,
    });
  }, [values, setValues, original]);

  const notesActionsButtons = [
    {
      Icon: SwapHorizIcon,
      color: 4,
      onClick: setOpenReassign,
      validation: showReassign,
      tooltip: "Reasignar folio",
    },
    {
      Icon: FlipCameraAndroidIcon,
      color: 0,
      onClick: setOpenUpdate,
      validation: showUpdate,
    },
    {
      Icon: VisibilityIcon,
      color: 0,
      onClick: setOpen,
      validation: showEdit,
    },
    {
      Icon: DeleteIcon,
      color: 3,
      onClick: handleRemoveNote,
      validation: showDelete,
    },
  ];

  const noteActionsButtons = [
    {
      Icon: EditIcon,
      color: 0,
      onClick: handleEdit,
    },
    {
      Icon: DeleteIcon,
      color: 3,
      onClick: handleRemove,
    },
  ];

  return {
    handleProductColumn,
    handleTypeColumn,
    handleQuantityColumn,
    handleRemoveNote,
    handleEdit,
    handleRemove,
    // ---------------------
    noteActionsButtons,
    notesActionsButtons,
    blockBtn,
    open,
    openDel,
    openUpdate,
    openReassign,
    setOpen,
    setOpenDel,
    setOpenUpdate,
    setOpenReassign,
    isLoadingComp,
  };
};
